import React from 'react';
import Header from '../components/Header';
import Hero from '../components/sections/HeroV2';
import About from '../components/sections/AboutV2';
import HowWeDoIt from '../components/sections/HowWeDoIt';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Contact from '../components/sections/ContactSimple';
import Footer from '../components/Footer';

const HomeV2 = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <HowWeDoIt />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomeV2;
